import { connect } from 'react-redux';
import PrivacyWrapper from './Form';
import {
    clearPrivacy,
    addFile,
    getLocales,
    savePrivacyFiles,
    getPrivacy,
    setPrivacyValue
} from './actions';
import {
    getPrivacyFiles,
    getPrivacyDescription,
    getPrivacyStatus,
    checkForErrors
} from './selectors';
import {
    readPrivacyVersions,
    enableUploadPrivacyFiles,
    editVersions
} from 'app/dux/profile/selectors';

const mapStateToProps = state => ( {
    files: getPrivacyFiles( state ),
    description: getPrivacyDescription( state ),
    status: getPrivacyStatus( state ),
    readPrivacyVersions: readPrivacyVersions( state ),
    enableUploadPrivacyFiles: enableUploadPrivacyFiles( state ),
    editVersions: editVersions( state )
} );

const mapDispatchToProps = {
    clearPrivacy,
    addFile,
    getLocales,
    savePrivacyFiles,
    getPrivacy,
    setPrivacyValue,
    checkForErrors
};

export default connect( mapStateToProps, mapDispatchToProps )( PrivacyWrapper );
